"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Auth = exports.ENV = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _user = require("../models/user");

/**
 * Environments you can use in {@link Auth}
 *
 * @enum {string}
 * @readonly
 */
const ENV = {
  DEV: 'https://api.accounts.estrategia-dev.com.br',
  QA: 'https://api.accounts.estrategia-qa.com.br',
  PROD: 'https://api.accounts.estrategiaeducacional.com.br',
  SANDBOX: 'https://api.accounts.estrategia-sandbox.com.br'
};
exports.ENV = ENV;

class Auth {
  /**
   * @param {string} baseURL - environment URL. You can use the enum {@link ENV}.
   * @param {string} requesterId - requesterId of the caller.
   * @param {number} timeout - request timeout in milliseconds
   */
  constructor(baseURL, requesterId, timeout = 10000) {
    if (!requesterId) {
      throw new Error('requester-id é obrigatório');
    }

    this._client = _axios.default.create({
      baseURL,
      timeout
    });

    this._client.interceptors.request.use(config => {
      // eslint-disable-next-line no-param-reassign
      config.headers['X-Requester-id'] = `frontend-libs/${requesterId}`; // eslint-disable-next-line no-param-reassign

      config.headers['X-Version'] = 'v2';
      return config;
    });
  }
  /**
   * Log into the system
   *
   * @param {string} email
   * @param {string} password
   * @returns {Promise<{user: User, token: string}>}
   */


  authenticate(email, password) {
    return this._client.post('/auth/login', {
      email,
      password
    }).then(res => {
      const auth = res.data.data;
      return {
        user: _user.User.fromJson(auth),
        token: auth.token
      };
    });
  }
  /**
   * Request a reset password email.
   *
   * The link returned will be on the form
   * <pre>
   * {target}?email={email}&id={id}&token={token}
   * </pre>
   *
   * For security, this method will always return 200, even if the email was not found.
   * You should create a generic page informing that
   * "if the email address exists on the database, a reset link will shortly arrive"
   *
   * @param {string} email - The user email
   * @param {string} target - A target url which the email will point to
   * @returns {Promise<empty>}
   */


  resetPassword(email, target) {
    return this._client.post('/auth/reset-token', {
      email,
      target
    }).then(resp => resp.data.data);
  }
  /**
   * Given the user id and token provided by the email sent by {@link resetPassword}, this method updates the user
   * password with the provided parameter `password`
   *
   * @param {string} id
   * @param {string} token
   * @param {string} password
   * @returns {Promise<User>}
   */


  changePasswordResetToken(id, token, password) {
    return this._client.post('/auth/reset-token/password', {
      id,
      token,
      password
    }).then(resp => resp.data.data);
  }
  /**
   * Given the token of a logged user, returns its data
   *
   * @param {string} token
   * @returns {Promise<User>}
   */


  getLoggedUser(token) {
    const headers = {
      Authorization: `Bearer ${token}`
    };
    return this._client.get('/user/me', {
      headers
    }).then(resp => _user.User.fromJson(resp.data.data));
  }

}

exports.Auth = Auth;